import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { contentStyles, h3 } from '@helpers/typography';
import svgSwoosh from '@img/icons/background/mep-swoosh-red.svg?url';
import styled from 'styled-components';
const Outer = styled.div `
  display: flex;
  overflow: hidden;
  height: 100%;

  &[data-site='ess'] {
    --bgColour: ${brand.global.white};
    --borderColour: ${brand.global.red};
    --fgColour: ${brand.ess.secondary.darkGrey};
    --titleColor: ${brand.ess.primary};

    padding-top: ${fluid(12, 17)};
  }

  &[data-site='mep'] {
    --bgColour: ${brand.global.red};
    --fgColour: ${brand.global.white};
    --titleColor: ${brand.global.white};
  }
`;
const ChevronIcon = styled.div `
  position: absolute;
  top: 0;
  right: 24px;
  background-color: var(--bgColour);
  height: ${fluid(24, 34)};
  color: var(--borderColour);
  transform: translateY(-50%);

  > svg {
    display: block;
    height: 100%;
    transform: translate(1px, -1px);
  }
`;
const Container = styled.div `
  padding: ${fluid(20, 40)};
  background-color: var(--bgColour);
  color: var(--fgColour);
  height: 100%;
  width: 100%;

  a& {
    display: block;
    text-decoration: none;

    .focus-ring & {
      outline: auto;
      outline-offset: 3px;
      outline-width: 2px;
      outline-style: solid;
    }
  }

  ${Outer}[data-site='ess'] & {
    position: relative;
    border: 2px solid var(--borderColour);

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -1px;
      right: -1px;
      height: ${fluid(36, 64)};
      width: ${fluid(36, 64)};
      transform: translate(50%, 50%) rotate(45deg);
      border-left: 2px solid var(--borderColour);
      background-color: var(--bgColour);
    }
  }

  ${Outer}[data-site='mep'] & {
    border-radius: 8px;
    background-image: url(${svgSwoosh});
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;
  }
`;
const Title = styled.h3 `
  ${h3};

  display: flex;
  align-items: center;
  color: var(--titleColor);

  ${Outer}[data-site='mep'] & {
    ${fonts.museoSlab.medium};
  }
`;
const IconWrapper = styled.span `
  margin: 0 ${fluid(8, 12)} 0 0;
  width: ${fluid(35, 45)};
`;
const Icon = styled.img `
  display: block;
  width: 100%;
`;
const Content = styled.div `
  ${contentStyles};

  > p {
    margin: 0 0 ${fluid(10, 14)};
    > a {
      color: var(--titleColor);
    }
  }
`;
const InformationCardStyles = {
    Container,
    Content,
    Title,
    IconWrapper,
    Icon,
    Outer,
    ChevronIcon,
};
export default InformationCardStyles;
